import React        from 'react';
import ReactTooltip from 'react-tooltip';
import '../css/aluno/style_aluno_lista.css'


function renderListAlunosFotos(props){

  if (props.length) {
      return  props.map((elem,i) => {
          return <div className="listar_user" key={i}>
                  <img 
                        width     = "40"
                        height    = "40"
                        className = "media-object img-rounded img-responsive"
                        alt="Foto"
                        data-tip 
                        data-for = {`user_${elem.use_id}`}
                        src      = {elem.use_foto}/>
                  <ReactTooltip 
                        id   = {`user_${elem.use_id}`}
                        type = 'light' effect='solid'>
                      <span>{elem.use_nome}</span>
                  </ReactTooltip>  
                </div>;
          });
  } else {
      return <span className='text-center'>Não existe aluno cadastrado.</span>;
  }

}


export default (props) => {

        return (
                <div className="conteudo_listar_user">
                    {renderListAlunosFotos(props.dadosUser)}
                </div>
               )
}



   


// WEBPACK FOOTER //
// ./src/container/renderListAvatarAlunos.js